import React from 'react';
import * as PropTypes from 'prop-types';
import FormHelperText from '@mui/material/FormHelperText';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';

import clsx from "clsx";
import Checkbox from '@mui/material/Checkbox';
function MyFormControlLabel(props){
  let { value, className, checked, ...rest} = props;
  function onChange(value){
    props?.onChange && props?.onChange(`${props?.name}[${props?.value}]`, !!value?.target?.checked)
  }

  if(checked){
    className = clsx(className, {'Mui-checked': true })
  }

  return <FormControlLabel
    {...rest}
    {...{
      onChange,
      className,
      checked,
      control: props?.control || <Checkbox />
    }}
  />
}

function Checkboxes(props){
  let { sx, onChange, name, label, control, inline, margin, variant, disabled, options, render, meta } = props;
  let { fullWidth, labelPlacement, value, classes, className, classNameFormLabel } = props;
  let { touched, error } = meta;

  const rest = { value, onChange, name, control, disabled, labelPlacement }

  options = (options || []).map(( { value: optValue, ...opt}, index)=>{
    let checked = false;
    if(value && value[optValue]){
      checked = true;
    }
    return { ...opt, checked }
  })

  return (
    <FormControl
      sx={sx} variant={variant} fullWidth={fullWidth} margin={margin}
      className={clsx(classes, className,{'d-flex': inline })}
    >
      {label && <label className={clsx('MuiFormLabel-root', classNameFormLabel)}>{label}</label>}
      <FormGroup>
        {(options || []).map((item, index) => {
          let { className, checked } = item || {};
          const label = typeof render === 'function' ? render(item): item?.label;
          return (<MyFormControlLabel
              key={index}
              {...rest}
              {...{ checked, label, className, value: index }}
            />
          )
        })}
      </FormGroup>
      {touched && (error && <FormHelperText>{error}</FormHelperText>)}
    </FormControl>
  )
}

Checkboxes.propTypes = {
  id: PropTypes.string,
  input: PropTypes.object,
  className: PropTypes.node,
  classNameGroup: PropTypes.node,
  classNameLabel: PropTypes.node,
  style: PropTypes.any,
  label: PropTypes.any,
  name: PropTypes.string,
  type: PropTypes.string,
  inline: PropTypes.bool,
  disabled: PropTypes.bool,
  options: PropTypes.array.isRequired,
  meta: PropTypes.object,
  labelPlacement: PropTypes.node,
  margin: PropTypes.node,
  fullWidth: PropTypes.bool
};

Checkboxes.defaultProps = {
  labelPlacement: 'end',
  margin: 'normal',
  disabled: false
};

export default Checkboxes;
